var _linearGradient, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtlassian = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0.291 -41.138 145.221 186.738",
  width: 1590,
  height: 2500
}, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
  id: "atlassian_svg__a",
  gradientTransform: "matrix(1 0 0 -1 0 228)",
  gradientUnits: "userSpaceOnUse",
  x1: 62.57,
  x2: 25.03,
  y1: 150.13,
  y2: 85.11
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0052cc"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.92,
  stopColor: "#2684ff"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M43 67a4.14 4.14 0 0 0-5.79-.78A4.29 4.29 0 0 0 36 67.73L.45 138.85a4.25 4.25 0 0 0 1.9 5.7 4.18 4.18 0 0 0 1.9.45h49.53a4.08 4.08 0 0 0 3.8-2.35C68.27 120.57 61.79 87 43 67z",
  fill: "url(#atlassian_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M69.13 2.28a93.82 93.82 0 0 0-5.48 92.61l23.88 47.76a4.25 4.25 0 0 0 3.8 2.35h49.52a4.24 4.24 0 0 0 4.25-4.25 4.31 4.31 0 0 0-.44-1.9L76.36 2.26a4 4 0 0 0-7.23 0z",
  fill: "#2684ff"
})));
export { SvgAtlassian as ReactComponent };
export default __webpack_public_path__ + "static/media/svg/atlassian.svg";